/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Nav
 */
export interface Nav {
    /**
     * 
     * @type {string}
     * @memberof Nav
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof Nav
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Nav
     */
    id?: string;
    /**
     * 
     * @type {Array<Nav>}
     * @memberof Nav
     */
    nav?: Array<Nav>;
}

/**
 * Check if a given object implements the Nav interface.
 */
export function instanceOfNav(value: object): value is Nav {
    return true;
}

export function NavFromJSON(json: any): Nav {
    return NavFromJSONTyped(json, false);
}

export function NavFromJSONTyped(json: any, ignoreDiscriminator: boolean): Nav {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'url': json['url'] == null ? undefined : json['url'],
        'id': json['id'] == null ? undefined : json['id'],
        'nav': json['nav'] == null ? undefined : ((json['nav'] as Array<any>).map(NavFromJSON)),
    };
}

export function NavToJSON(value?: Nav | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'url': value['url'],
        'id': value['id'],
        'nav': value['nav'] == null ? undefined : ((value['nav'] as Array<any>).map((v) => NavToJSON(v))),
    };
}

